import { TitleButton } from '@/common/buttons/TitleButton';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { Form } from '@/common/form/Form';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/MainBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { McdDispBreakdownPieChart } from '@/sc/entities/mcdInv/dashboard/fin/McdDispBreakdownPieChart';
import { McdDispTrendChart } from '@/sc/entities/mcdInv/dashboard/fin/McdDispTrendChart';
import { McdFinTopCtrtCard } from '@/sc/entities/mcdInv/dashboard/fin/McdFinTopCtrtCard';
import { far, fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, styled } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { AnomalyDetectionCard } from './AnomalyDetectionCard';
import { DispTrendsCard } from './DispTrendsCard';
import { PaidTrendsCard } from './PaidTrendsCard';

export const McdFinDashboard = () => {

  const rsrc = useRsrc();
  const { navState } = useNavState();

  // Filters
  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');
  const defaultFormValues = useRef();

  useEffect(() => {
    rsrc.data('sc', 'MCD_FIN_DASHBOARD_FILTER_DATA_PLUGIN', {}).then(res => {
      setFieldDefs([
        { field: 'rbtPeriodId', displayName: 'Rebate Period', type: 'DROPDOWN', values: res.periods },
        { field: 'stateIds', displayName: 'States', type: 'TREE', treeData: res.stateTreeData },
        { field: 'ctrtIds', displayName: 'Contracts', type: 'TREE', treeData: res.ctrtTreeData },
        { field: 'brandProdIds', displayName: 'Brands', type: 'TREE', treeData: res.brandProdTreeData },
      ]);

      defaultFormValues.current = {
        rbtPeriodId: res.periods[0]?.value,
        stateIds: res.stateIds,
        ctrtIds: res.ctrtIds,
        brandProdIds: res.brandProdIds,
      }

      if (!navState.formValues) {
        setFormValues(defaultFormValues.current);
      }
    });

  }, []);

  const resetFilters = () => {
    setFormValues(defaultFormValues.current);
  }

  if (!fieldDefs) {
    return;
  }

  return (
    <ContentBox>
      {/* Title */}
    
      <Title
        icon={fas.faTasks}
        title="Medicaid Financial Dashboard" buttons={ 
          <TitleButton key="resetViewButton" dataTestId="reset-view-button" icon={far.faWindowRestore} toolTip="Reset Filters" onClick={resetFilters} />
        }
      />
    
      {/* Filters */}
      <Form fieldDefs={fieldDefs} formValues={formValues} setFormValues={setFormValues} container={FilterContainer}/>

      {/* Main Contents */}
      <SpacerLayout>
        <Spacer vertical>
          {/* Row 1 */}
          <Spacer weights={[3, 5, 5]}>
            <AnomalyDetectionCard setFormValues={setFormValues} defaultFormValues={defaultFormValues.current} />
            <PaidTrendsCard formValues={formValues} />
            <DispTrendsCard formValues={formValues} />
          </Spacer>

          {/* Row 2 */}
          <Spacer weights={[5, 3, 5]}>
            <McdFinTopCtrtCard formValues={formValues} />

            <DashboardCard title="Dispute Code Breakdown" >
              <McdDispBreakdownPieChart formValues={formValues} />
            </DashboardCard>

            <DashboardCard title="Dispute Code Trends" >
              <McdDispTrendChart formValues={formValues} />
            </DashboardCard>
          </Spacer>
        </Spacer>
      </SpacerLayout>
    </ContentBox>
  );
};

// TODO: Standardize Dashboards
const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(2),
  
}));